
import { useEffect, useState } from "react";

import { ProgressIndicator } from "components/Elements/ProgressIndicator";
import useFetchWithMsal from "hooks/useFetchWithMsal";
import { apiConfig } from "config/apiConfig";
import DataBoundSelect from "components/Elements/DataBound/Dropdown";
import DataBoundList from "components/Elements/DataBound/List";
import { useBookDataLoader } from "layouts/Book/components";
import { useProgressIndicator } from "components/Elements/ProgressIndicator";
import SoftTypography from "components/SoftTypography";

const BookPlayerSelector = ({ cardroom, book, eligblePlayers, value, readonly, placeholder, emptyValue, onSelectionChanged, type, onBuildListItem, reload, maxHeight }) => {

    const [players, setPlayers] = useState(eligblePlayers || (book && book.players ? book.players : null));

    const [retryCounter, setRetryCounter] = useState(0);

    function handleRetry() {
        setRetryCounter(retryCounter + 1);
    }
    const [showProgress, progressIndicatorProps] = useProgressIndicator("wait", "retrieving players...", handleRetry)


    const [availableOptions, setAvailableOptions] = useState(null);

    const [selectedValue, setSelectedValue] = useState(value ? value : emptyValue);
    const [selectedIndex, setSelectedIndex] = useState(null);

    function getSelectedIndex(dataSource) {
        if (!dataSource) dataSource = availableOptions; // getDataSource();

        if (!dataSource) return -1;
        if (!selectedValue) return -1;

        for (var i = 0; i < dataSource.length; i++) {
            if (dataSource[i].id == selectedValue.id || dataSource[i].id == selectedValue) {
                return i;
            }
        }

        return -1;
    }

    function findValueInDataSource(v) {
        let dataSource = getDataSource();

        if (!dataSource) return null;
        if (!v) return null;

        for (var i = 0; i < dataSource.length; i++) {
            if (dataSource[i].id == v.id || dataSource[i].id == v) {
                return dataSource[i];
            }
        }

        return -1;
    }

    function getDataSource() {

        // if (!players) return null;

        let p = players || [];

        let rows = [...p];

        if (rows.length > 0) {
            rows.sort(function (a, b) {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            });
        }

        if (emptyValue) {
            rows.unshift(emptyValue);
        }

        return rows;
    }

    function handlePlayerChange({ item, index }) {
        setSelectedIndex(null);
        setSelectedValue(item);

        if (onSelectionChanged) {
            onSelectionChanged(item);
        }
    }

    const bookRequest = useFetchWithMsal({
        scopes: apiConfig.book.scopes.read,
    });

    const bookDataLoader = useBookDataLoader();

    useEffect(() => {
        if (reload === true) {
            setPlayers(null);
            setSelectedIndex(-1);
        }
    }, [reload]);

    useEffect(() => {
        if (!players && book) {

            progressIndicatorProps.setMode("wait");
            progressIndicatorProps.setMessage("retrieving players...")
            showProgress();

            //loadAgents: function (request, cardroom, book, enableCache, onsuccess, onerror) 
            bookDataLoader.entity.loadPlayers(bookRequest, cardroom, book, true, (ags) => {
                if (ags) {
                    setPlayers(ags);
                }
                progressIndicatorProps.close();
            }, (err) => {
                progressIndicatorProps.setMode("errorWithRetry");
                progressIndicatorProps.setMessage("Unable to retrieve players, please try again...")
            });
        }

    }, [bookRequest.execute, players, book, retryCounter]);

    useEffect(() => {

        if (players) {

            const data = getDataSource();
            setAvailableOptions(data);

            if (selectedValue && (!selectedIndex)) {
                var idx = getSelectedIndex(data);
                setSelectedIndex(idx);

                if (onSelectionChanged && idx >= 0) {
                    onSelectionChanged(data[idx]);
                }
            }
        }

    }, [players, selectedIndex, selectedValue]);

    useEffect(() => {
        if (players && value) {
            //find in datasource
            //handleAgentChange(findValueInDataSource(value));
            // setSelectedIndex(null); --this needs to be done sometimes
            setSelectedValue(findValueInDataSource(value));
        }

    }, [players, value]);

    return <>
        <ProgressIndicator  {...progressIndicatorProps} />
        {!progressIndicatorProps.visible ? <>
            {readonly ?
                <SoftTypography
                    variant="caption"
                    fontWeight="regular"
                    color="dark"
                > {selectedValue ? selectedValue.name : "[None]"}
                </SoftTypography> : <>{availableOptions ?
                    <>
                        {type === "dropdown" ?
                            <DataBoundSelect placeholder={placeholder} data={availableOptions} valueName="id" textName="name" onChange={handlePlayerChange} size="medium" selectedIndex={selectedIndex} /> : null}
                        {type === "list" ? <DataBoundList data={availableOptions} valueName="id" textName="name" onChange={handlePlayerChange} selectedIndex={selectedIndex} onBuildListItem={onBuildListItem} maxHeight={maxHeight} /> : null}

                    </>
                    : null}
                </>
            }</> : null}
    </>;


};


export default BookPlayerSelector;